import React from 'react'
import PageHeader from '../../components/PageHeader'
export default function FourZeroFour() {
	return <main>
		<PageHeader title={'404'} />
		<div className='page-container'>
			<h1>Looks like you went down the rabbit hole</h1>
		</div>
	</main>
}